import React from 'react';

const WindowsLogo: React.FC<{ className?: string }> = ({ className = '' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 4875 4875"
        className={className}
    >
        <path fill="currentColor" d="M0 0h2311v2310H0zm2564 0h2311v2310H2564zM0 2564h2311v2311H0zm2564 0h2311v2311H2564" />
    </svg>
);

export default WindowsLogo;